var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.resultMessageKey)?_c('router-link',{staticClass:"bc-recommend-warning-errors bcx-pointer",class:_setup.warningClass,attrs:{"to":"/recommendations"}},[_vm._v(" "+_vm._s(_setup.t(_vm.resultMessageKey))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }